import { Logger } from 'logger';

const debugLog = Logger.create('OpenfinService.ts')

const fin = (window as any).fin
interface IMessageHandler {
  name: string,
  cb: (payload: object, identity?: object) => void
}

export const makeChannelProvider = async (channelName: string, handlers: IMessageHandler[]) => {
  const provider = await fin.InterApplicationBus.Channel.create(channelName)
  provider.onConnection((identity: object, payload: object) => {
    debugLog(`onConnection identity: ${JSON.stringify(identity)}`);
  })
  provider.onDisconnection((identity: object) => {
    debugLog(`onDisconnection identity: ${JSON.stringify(identity)}`);
  })
  handlers.forEach(handler => {
    provider.register(handler.name, handler.cb);
  })

  return provider;
}

export const makeChannelListener = async (channelName: string): Promise<(messageName: string, payload: object) => void> => {
  const client = await fin.InterApplicationBus.Channel.connect(channelName, null);
  return (messageName, payload) => { client.dispatch(messageName, payload)};
}
